import { memo } from 'react';

import N8NIcon from '@/assets/n8n-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type N8NLogoProps = LogoProps;

const IN8NLogo = ({ className, ...rest }: N8NLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <N8NIcon className="size-5" />
    </Logo>
  );
};

export const N8NLogo = memo(IN8NLogo) as typeof IN8NLogo;
